import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';

import { registerLocaleData, PathLocationStrategy, LocationStrategy } from '@angular/common';
import en from '@angular/common/locales/en';

import { AppRoutingModule } from './app-routing.module';
import { TemplateModule } from './shared/template/template.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';


import { ThemeConstantService } from './shared/services/theme-constant.service';
import { ReactiveFormsModule } from '@angular/forms';
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { JwtModule } from "@auth0/angular-jwt";
import { NgZorroAntdModule } from './ng-zorro-antd.module';
import { PqiHubModule } from './pqi-hub/pqi-hub.module';
import { PqiJobsModule } from './pqi-jobs/pqi-jobs.module';
import { SfdcSyncModule } from './sfdc-sync/sfdc-sync.module';
import { VjwebModule } from './vj-offices/vjweb.module';
import { VjwebRoutingModule } from './vj-offices/vjweb-routing.module';
import { AuthModule } from './pqi-admin/auth.module';
import { VjThemeLayoutComponent } from './layouts/vj-theme-layout/vj-theme-layout.component';
import { PublicWebModule } from './public-web/public-web.module';
import { HttpLoadingInterceptor } from './shared/interceptor/http-loading.interceptor';

registerLocaleData(en);
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.uiClienId, // PPE testing environment PID client Id
      authority: 'https://login.microsoftonline.com/'+environment.tenantId, // Prod environment. Uncomment to use.
     redirectUri: environment.redirectUrl,
       postLogoutRedirectUri: environment.redirectUrl,
     },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      // loggerOptions: {
      //   loggerCallback,
      //   logLevel: LogLevel.Info,
      //   piiLoggingEnabled: false
      // }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string> | null>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
 //protectedResourceMap.set(environment.apiClienId, ['access_as_user']);
 //protectedResourceMap.set(environment.baseUrl+'public-web',null);
 //protectedResourceMap.set(environment.baseUrl+'auth', ['api://'+environment.apiClienId+'/access_as_user']);
 
  protectedResourceMap.set(environment.baseUrl+'pqi-abr/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'pqi-jobs/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'pqi-hub/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'vj-marketing/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'sfdc-sync/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'auth/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'diligent-jobs/', ['api://'+environment.apiClienId+'/access_as_user']);
  protectedResourceMap.set(environment.baseUrl+'common-utility/', ['api://'+environment.apiClienId+'/access_as_user']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['api://'+environment.apiClienId+'/access_as_user']
    },
    //loginFailedRoute: '/login-failed'
  };
}

export function tokenGetter() {
  return localStorage.getItem("accessToken");
}
@NgModule({
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        FullLayoutComponent,
        HomeLayoutComponent,
        VjThemeLayoutComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NzBreadCrumbModule,
        TemplateModule,
        NgZorroAntdModule,
        ReactiveFormsModule,
        MsalModule,
        PublicWebModule,
        HttpClientModule,
        JwtModule.forRoot({
          config: {
            tokenGetter: tokenGetter,
            allowedDomains: ["*"]
          },
        }),
    ],
    providers: [
        {
            provide: NZ_I18N,
            useValue: en_US,
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        ThemeConstantService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
          },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpLoadingInterceptor,
            multi: true
          },
          {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
          },
          {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
          },
          {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
          },
          MsalService,
          MsalGuard,
          MsalBroadcastService
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { 
    }
